var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "emailPage"
  }, [_c('h1', [_c('img', {
    attrs: {
      "src": _vm.homeLogo
    }
  }), _c('span', [_vm._v("TVU " + _vm._s(_vm.$cm.title))])]), _c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title))]), _c('el-divider'), _vm.type == 1 ? _c('p', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.contents))]) : _vm._e(), _vm.acceptVal && (_vm.type == 0 || !_vm.type) ? _c('p', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.content))]) : _vm._e(), _vm.acceptVal && (_vm.type == 0 || !_vm.type) ? _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t("personalInfo.collaboratePopupDetail1")))]), _c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t("personalInfo.collaboratePopupDetail2")))]), _c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t("personalInfo.collaboratePopupDetail3")))])]) : _vm._e(), _c('el-button', {
    staticClass: "right",
    on: {
      "click": _vm.jump
    }
  }, [_vm._v(_vm._s(_vm.buttonText))])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };